import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
  Box,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { AutoAwesome } from "@mui/icons-material";
import content from "../data/ai-generated-job-content.json";

interface PromptDialogProps {
  open: boolean;
  onClose: () => void;
  onGenerate: (prompt: string) => void;
  title?: string;
}

const PromptDialog: React.FC<PromptDialogProps> = ({
  open,
  onClose,
  onGenerate,
  title = "Generate with AI",
}) => {
  const [prompt, setPrompt] = useState("");

  const handleGenerate = () => {
    onGenerate(content.jobContent);
    setPrompt(""); // Clear after submit
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">{title}</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          multiline
          minRows={4}
          label="Enter your prompt"
          className="mt-8"
          variant="outlined"
          value={prompt}
          onChange={(e) => setPrompt(e.target.value)}
        />
      </DialogContent>
      <DialogActions className="mb-8 mr-16">
        <Button
          onClick={() => {
            setPrompt("");
          }}
          color="secondary"
        >
          Clear
        </Button>
        <Button
          onClick={handleGenerate}
          variant="contained"
          color="primary"
          disabled={!prompt.trim()}
          startIcon={<AutoAwesome />}
        >
          Generate
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PromptDialog;
